<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>客户档案</el-breadcrumb-item>
            <el-breadcrumb-item>评分</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-tabs v-model="activeName" type="border-card" @tab-click="tabClick">
          <el-tab-pane
            :name="item.Month.toString()"
            :key="'tab-pane_' + index"
            v-for="(item, index) in customerMark"
          >
            <span slot="label"
              >{{ item.Month }}月<i>({{ item.TotalScore }})</i></span
            >
            <el-row>
              <div class="main_title">
                <span class="tit">档案更新</span>
              </div>
              <div class="nohas" v-if="item.LogList.length == 0">暂无数据</div>
              <div class="block">
                <el-timeline>
                  <el-timeline-item
                    v-for="(childItem1, index) in item.LogList"
                    :key="index"
                  >
                    <div class="minbox">
                      <div class="fl">
                        对<span class="cy">{{ childItem1.Type }}</span
                        >进行了{{ childItem1.ActionType }}
                      </div>
                      <div class="fr">更新时间：{{ childItem1.AddTime }}</div>
                    </div>
                  </el-timeline-item>
                </el-timeline>
              </div>
              <div class="main_title">
                <span class="tit">出访复盘</span>
              </div>
              <el-table :data="item.ReviewList" style="width: 100%">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-form
                      label-position="left"
                      inline
                      class="demo-table-expand"
                    >
                      <el-form-item>
                        <div class="itemMin">
                          <span class="w1">出访地址：</span>
                          <span class="w2">{{ props.row.Area }}</span>
                        </div>
                        <div class="itemMin">
                          <span class="w1">出访目的：</span>
                          <span class="w2">{{ props.row.Purpose }}</span>
                        </div>
                        <div class="itemMin">
                          <span class="w1">开始时间：</span>
                          <span class="w2">{{ props.row.startTime }}</span>
                        </div>
                        <div class="itemMin">
                          <span class="w1">结束时间：</span>
                          <span class="w2">{{ props.row.endTime }}</span>
                        </div>
                        <div class="itemMin">
                          <span class="w1">问题卡点：</span>
                          <span class="w2">{{ props.row.Question }}</span>
                        </div>
                        <div class="itemMin">
                          <span class="w1">下步规划：</span>
                          <span class="w2">{{ props.row.Planning }}</span>
                        </div>
                      </el-form-item>
                      <el-form-item>
                        <div class="itemMin">
                          <span class="w1">出访水印打卡照片：</span>
                          <img
                            class="itemPic"
                            :src="props.row.PunchPic"
                            alt=""
                          />
                        </div>
                        <div class="itemMin">
                          <span class="w1">客户沟通记录截图：</span>
                          <img
                            class="itemPic"
                            v-if="props.row.RecordPic"
                            :src="props.row.RecordPic"
                            alt=""
                          />
                        </div>
                        <div class="itemMin">
                          <span class="w1">客户数据复盘报表：</span>

                          <div class="lh-14">
                            <i class="el-icon-folder-opened"></i>
                            <el-button
                              type="text"
                              size="small"
                              @click="handleChangeUrl(props.row.ReviewReport)"
                              >下载</el-button
                            >
                          </div>
                        </div>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column label="出访地址" prop="Area">
                </el-table-column>
                <el-table-column label="出访目的" prop="Purpose">
                </el-table-column>
                <el-table-column label="开始时间" prop="startTime">
                </el-table-column>
                <el-table-column label="结束时间" prop="endTime">
                </el-table-column>
                <el-table-column label="问题卡点" prop="Question">
                </el-table-column>
                <el-table-column label="下步规划" prop="Planning">
                </el-table-column>
              </el-table>
              <div class="main_title">
                <span class="tit">推广提案</span>
              </div>
              <div class="nohas" v-if="item.ProposalList.length == 0">
                暂无数据
              </div>
              <div class="block">
                <el-timeline>
                  <el-timeline-item
                    v-for="(childItem2, index) in item.ProposalList"
                    :key="index"
                  >
                    <div class="minbox">
                      <div class="fl">
                        <i class="el-icon-folder-opened"></i>
                        <el-button
                          type="text"
                          size="small"
                          @click="handleChangeUrl(childItem2.Proposal)"
                          >下载</el-button
                        >
                      </div>
                      <div class="fr">上传时间：{{ childItem2.AddTime }}</div>
                    </div>
                  </el-timeline-item>
                </el-timeline>
              </div>
              <div class="main_title">
                <span class="tit">优化诊断</span>
              </div>
              <el-table :data="item.DiagnosisList" style="width: 100%">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-form
                      label-position="left"
                      inline
                      class="demo-table-expand"
                    >
                      <el-form-item label="账户问题及动作:">
                        <span>{{ props.row.Approach }}</span>
                      </el-form-item>
                      <el-form-item label="卡点:">
                        <span>{{ props.row.Question }}</span>
                      </el-form-item>
                      <el-form-item label="下步规划:">
                        <span>{{ props.row.Planning }}</span>
                      </el-form-item>
                      <el-form-item label="所需支持:">
                        <span>{{ props.row.Support }}</span>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column label="账户问题及动作" prop="Approach">
                </el-table-column>
                <el-table-column label="下步规划" prop="Planning">
                </el-table-column>
                <el-table-column label="卡点" prop="Question">
                </el-table-column>
                <el-table-column label="所需支持" prop="Support">
                </el-table-column>
                <el-table-column label="创建时间" prop="AddTime">
                </el-table-column>
              </el-table>
              <div class="main_title">
                <span class="tit">本月评分</span>
                <el-link
                  type="primary"
                  :underline="false"
                  @click="handleChangeModifyScore"
                  >修改得分</el-link
                >
              </div>
              <el-descriptions direction="vertical" :column="12" :border="true">
                <!-- <el-descriptions-item label="客户层级">{{
                  item.CusScore.Grade
                }}</el-descriptions-item> -->
                <el-descriptions-item label="客户名称">{{
                  item.CusScore.Name
                }}</el-descriptions-item>
                <el-descriptions-item label="账户名称">{{
                  item.CusScore.AccountName
                }}</el-descriptions-item>
                <el-descriptions-item label="账户ID"
                  >{{ item.CusScore.AccountID }}
                </el-descriptions-item>
                <el-descriptions-item label="上月消费日均">{{
                  item.CusScore.MonthlyBudget
                }}</el-descriptions-item>
                <el-descriptions-item label="优化师">{{
                  item.CusScore.UserName
                }}</el-descriptions-item>
                <el-descriptions-item label="客户档案评分">{{
                  item.CusScore.FileScore
                }}</el-descriptions-item>
                <el-descriptions-item label="出访复盘评分">{{
                  item.CusScore.ReviewScore
                }}</el-descriptions-item>
                <el-descriptions-item label="推广提案评分">{{
                  item.CusScore.ProposalScore
                }}</el-descriptions-item>
                <el-descriptions-item label="优化诊断评分">{{
                  item.CusScore.OptimizationScore
                }}</el-descriptions-item>
                <el-descriptions-item label="客户满意度">{{
                  item.CusScore.SatisfactionScore
                }}</el-descriptions-item>
                <el-descriptions-item label="总分">{{
                  item.CusScore.TotalScore
                }}</el-descriptions-item>
              </el-descriptions>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-row>
      <!-- 修改得分 -->
      <el-dialog title="修改得分" :visible.sync="markVisible" width="50%">
        <div class="block">
          <el-row>
            <el-form
              :model="markObj"
              :rules="rules"
              ref="ruleForm"
              label-width="140px"
            >
              <el-form-item label="客户档案评分:" prop="FileScore">
                <el-input
                  @change="changeMark"
                  v-model="markObj.FileScore"
                ></el-input>
              </el-form-item>
              <el-form-item label="出访复盘评分:" prop="ReviewScore">
                <el-input
                  @change="changeMark"
                  v-model="markObj.ReviewScore"
                ></el-input>
              </el-form-item>
              <el-form-item label="推广提案评分:" prop="ProposalScore">
                <el-input
                  @change="changeMark"
                  v-model="markObj.ProposalScore"
                ></el-input>
              </el-form-item>
              <el-form-item label="优化诊断评分:" prop="OptimizationScore">
                <el-input
                  @change="changeMark"
                  v-model="markObj.OptimizationScore"
                ></el-input>
              </el-form-item>
              <el-form-item label="客户满意度:" prop="SatisfactionScore">
                <el-input
                  @change="changeMark"
                  v-model="markObj.SatisfactionScore"
                ></el-input>
              </el-form-item>
              <el-form-item label="总分:" prop="TotalScore">
                <el-input
                  placeholder=""
                  v-model="markObj.TotalScore"
                  disabled
                ></el-input>
              </el-form-item>
            </el-form>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="markVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleChangeScore">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
/**
 * API接口内容
 * */
import {
  getCustomerMark,
  SetCustomerScore,
} from "@/until/ZeusApiSDK/Logic/CustomerProfile";

/**
 * 用户信息API接口
 * */
import {
  GetCurrentUserInfo,
  GetCurrentUserRole,
} from "@/until/ZeusApiSDK/Logic/HomeLogic";

export default {
  data() {
    return {
      activeName: "",
      tabIndex: 0,
      customerid: "",
      customerMark: {},
      rules: {
        FileScore: [
          {
            required: true,
            message: "请输入客户档案评分",
            trigger: "blur",
          },
        ],
        ReviewScore: [
          {
            required: true,
            message: "请输入出访复盘评分",
            trigger: "change",
          },
        ],
        ProposalScore: [
          {
            required: true,
            message: "请输入推广提案评分",
            trigger: "change",
          },
        ],
        OptimizationScore: [
          {
            required: true,
            message: "请输入优化诊断评分",
            trigger: "change",
          },
        ],
        SatisfactionScore: [
          {
            required: true,
            message: "请输入客户满意度",
            trigger: "change",
          },
        ],
      },
      markObj: {
        FileScore: 0,
        ReviewScore: 0,
        ProposalScore: 0,
        OptimizationScore: 0,
        SatisfactionScore: 0,
        TotalScore: 0,
      },
      markVisible: false,
      newTotalScore: 0,
      options: [],
      Info: GetCurrentUserInfo(),
      customerSingle: {},
      cusScoreSingle: {},
    };
  },
  created() {
    GetCurrentUserRole().then((res) => {
      let Info = GetCurrentUserInfo();
      this.customerSingle.UserId = Info.UserCode;
      this.customerSingle.UserName = Info.TrueName;
      this.customerSingle.Id = res.Id;
      if (res.Key == "admin") {
        this.Info.admin = "true";
      }

      this.customerid = this.$route.params.customerid;
      this.APIGetCustomerMark(this.customerid);
    });
  },
  methods: {
    // 获取数据
    APIGetCustomerMark(prams) {
      getCustomerMark(prams).then((res) => {
        for (let i = 0, len = res.length; i < len; i++) {
          for (
            let j = 0, _length = res[i].ReviewList.length;
            j < _length;
            j++
          ) {
            let timeArr = res[i].ReviewList[j].Time.split(",");
            res[i].ReviewList[j].startTime = timeArr[0];
            res[i].ReviewList[j].endTime = timeArr[1];
          }
        }
        console.log(res[2].ReviewList[0]);
        this.customerMark = res;
        this.activeName = res.length + "";
        var CusScore = res[res.length - 1].CusScore;
        this.cusScoreSingle = res[res.length - 1].CusScore;
        this.markObj.FileScore = CusScore.FileScore;
        this.markObj.ReviewScore = CusScore.ReviewScore;
        this.markObj.ProposalScore = CusScore.ProposalScore;
        this.markObj.OptimizationScore = CusScore.OptimizationScore;
        this.markObj.SatisfactionScore = CusScore.SatisfactionScore;
        this.markObj.TotalScore = CusScore.TotalScore;
      });
    },
    // 月份切换
    tabClick(tab) {
      this.tabIndex = tab.index;
      this.cusScoreSingle = this.customerMark[tab.index].CusScore;
      var CusScore = this.customerMark[tab.index].CusScore;
      this.newTotalScore = CusScore.TotalScore;
      this.markObj.FileScore = CusScore.FileScore;
      this.markObj.ReviewScore = CusScore.ReviewScore;
      this.markObj.ProposalScore = CusScore.ProposalScore;
      this.markObj.OptimizationScore = CusScore.OptimizationScore;
      this.markObj.SatisfactionScore = CusScore.SatisfactionScore;
      this.markObj.TotalScore = CusScore.TotalScore;
    },
    changeMark() {
      let totalScore = 0;
      let ergodicArr = [
        this.markObj["FileScore"],
        this.markObj["ReviewScore"],
        this.markObj["ProposalScore"],
        this.markObj["OptimizationScore"],
        this.markObj["SatisfactionScore"],
      ];
      for (let i = 0, len = ergodicArr.length; i < len; i++) {
        totalScore += parseInt(ergodicArr[i]);
      }
      this.markObj.TotalScore = totalScore;
    },
    handleChangeScore() {
      let _param = {
        ...this.markObj,
        TotalScore: this.markObj["TotalScore"] + "",
        CustomerId: this.customerid,
        Id: this.cusScoreSingle.Id,
        Month: this.cusScoreSingle.Month,
        RaterId:this.Info.UserCode,
        RaterName:this.Info.TrueName
      };
      SetCustomerScore(_param).then((res) => {
        this.$message({
          message: "修改成功!",
          type: "success",
        });
        this.markVisible = false;
        this.cusScoreSingle = res;
        let arrIndex = parseInt(this.activeName) - 1;
        this.$set(this.customerMark[arrIndex], "CusScore", res);
        this.$set(this.customerMark[arrIndex], "TotalScore", res.TotalScore);
      });
    },
    handleChangeModifyScore() {
      this.markVisible = true;
    },
    handleChangeUrl(docUrl) {
      window.location.href = docUrl;
    },
  },
};
</script>

<style lang="less" scoped>
i {
  font-style: normal;
}

.searchText {
  float: left;
  line-height: 40px;
  margin-right: 8px;
}

.main_title {
  display: flex;
  justify-content: space-between;
  margin: 15px 0;
}

.main_title .tit {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.minbox {
  display: flex;
  justify-content: space-between;
  .fl {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}

.minbox .cy {
  display: inline-block;
  margin: 0 8px;
  color: #f59a23;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 130px;
  color: #99a9bf;
  text-align: right !important;
}

.demo-table-expand .el-form-item {
  margin-right: 0 !important;
  margin-bottom: 0;
  width: 50%;
}

.itemMin {
  display: flex;
  margin-bottom: 10px;
}

.itemMin .w1 {
  margin-right: 6px;
}

.itemPic {
  width: 110px;
  height: 110px;
}

::v-deep .el-icon-folder-opened {
  font-size: 30px;
  color: #999;
  margin-right: 10px;
}

::v-deep .el-timeline-item__node {
  background: #fff !important;
  box-sizing: border-box;
  border: 3px solid #409eff;
}
.lh-14 {
  line-height: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.nohas{
  font-size: 14px;
    color: #909399;
    padding:10px 0;
}
</style>
